<template>
    
            <v-card style="min-height: 85vh !important;">
                <v-card-title class="pt-7 pb-7"><b>Nouveau Proforma D/A</b></v-card-title>
                <v-card-text class="pt-7 pb-7">
                        <v-snackbar
                            v-model="snackbar"
                            :color="color"
                            right
                            top
                            multi-line
                            app
                        >
                            {{snackbarText}}
                            <v-btn
                            text
                            dark
                            @click="snackbar = false"
                            >
                            Fermer
                            </v-btn>
                        </v-snackbar>
                        <v-tabs
                        hide-slider
                        v-model="tab"
                        background-color="transparent"
                        grow
                        >
                        <v-tab
                            v-for="item in itemsTabs"
                            class="avis-tab"
                            :key="item"
                        >
                            {{ item }}
                        </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tab">
                        <v-tab-item>
                            <v-form v-model="valid">
                            <v-row class="mt-5">
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        dense
                                        v-model="currentDossier.numdossier"
                                        label="Référence"
                                        disabled
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Avis N°"
                                        v-model="avisTmp.num_avis"
                                        dense
                                        disabled
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Type Dossier"
                                        v-model="currentDossier.type"
                                        dense
                                        disabled
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Classe Dossier"
                                        v-model="currentDossier.classe"
                                        dense
                                        disabled
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Date Proforma"
                                        dense
                                        v-model="todayDate"
                                        :value=todayDate
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        v-model=currentDossier.escale
                                        label="Escale"
                                        disabled
                                        dense
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        v-model=currentDossier.voyage
                                        label="Voyage"
                                        dense
                                        disabled
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Consignataire"
                                        dense
                                        disabled
                                        v-model=currentDossier.consig
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Armateur Navire"
                                        v-model=currentDossier.armateur
                                        disabled
                                        dense
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Navire"
                                        v-model=currentDossier.navire
                                        disabled
                                        dense
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Date d'embarquement"
                                        dense
                                        :value="currentDossier.from_date | formatDate"
                                        disabled
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Port d'embarquement"
                                        v-model=currentDossier.port_from
                                        disabled
                                        dense
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Date de débarquement"
                                        :value="currentDossier.to_date | formatDate"
                                        disabled
                                        dense
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Port de débarquement"
                                        v-model=currentDossier.port_to
                                        disabled
                                        dense
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Longueur"
                                        v-model=avisTmp.longueur
                                        @change="calculateVolume"
                                        dense
                                        number
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Largeur"
                                        v-model=avisTmp.largeur
                                        @change="calculateVolume"
                                        dense
                                        number
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Tirant D'eau (Max)"
                                        v-model=avisTmp.max_draft
                                        @change="calculateVolume"
                                        dense
                                        number
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Volume"
                                        v-model="avisTmp.volume"
                                        dense
                                        disabled
                                        number
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                
                                
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="3" md="3">
                                    <v-select label="Devise" @change="changeCurrency" outlined dense v-model="avisTmp.devise" :items="['USD', 'EUR']" :value="'EUR'" required></v-select>
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <v-text-field
                                        label="Cours"
                                        dense
                                        v-model="avisTmp.cour"
                                        :rules="infoRules"
                                        outlined
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <v-text-field
                                        label="P/C"
                                        dense
                                        v-model="avisTmp.pc"
                                        :rules="infoRules"
                                        outlined
                                        required
                                    ></v-text-field>
                                </v-col>
                                
                                <v-col cols="12" sm="3" md="3">
                                    <v-autocomplete
                                        v-model="avisTmp.agent_id"
                                        :items="agentList"
                                        item-text="nom"
                                        item-value="id"
                                        outlined
                                        required
                                        :rules="infoRules"
                                        dense
                                        label="Agent commercial"
                                    ></v-autocomplete>
                                </v-col>
                                
                                <v-col cols="12" sm="3" md="3">
                                    <v-text-field
                                        label="Terme"
                                        dense
                                        v-model="avisTmp.terme"
                                        :rules="infoRules"
                                        required
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <!--<v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                        label="Expéditeur"
                                        dense
                                        v-model="avisTmp.expediteur"
                                        outlined
                                        :rules="infoRules"
                                        required
                                    ></v-text-field>
                                </v-col>-->
                                <v-col cols="12" sm="3" md="3">
                                    <v-text-field
                                        label="Fournisseur"
                                        dense
                                        v-model="avisTmp.fournisseur"
                                        outlined
                                        :rules="infoRules"
                                        required
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            </v-form>
                        </v-tab-item>
                        <v-tab-item class="mt-5">
                                <v-row>
                                    <!--<v-col cols="12" md="3">
                                        <v-alert
                                        text
                                        class="text-left"
                                        color="info"
                                        >
                                        <div>Pour ajouter une préstation, il suffit d'en cliquer et elle s'ajoutera automatiquement.</div>
                                        </v-alert>
                                        <v-text-field v-model="searchPrest" append-icon="mdi-magnify" label="Rechercher une prestation.." hide-details></v-text-field>
                                        <v-treeview 
                                            style="text-align:left;"
                                            v-model="tree"
                                            :items="items"
                                            activatable
                                            :search="searchPrest"
                                            item-key="id"
                                            open-on-click
                                        >
                                        <template slot="label" slot-scope="{ item }">
                                        <a v-if="item.name !== 'Préstations' && item.name !== 'Fret'" style="width: 100%;display: block;padding: 15px;" @click="selectPrest(item.code_prestation, prestations.length)">{{ item.name }}</a>
                                        <a v-else style="width: 100%;display: block;padding: 15px;">{{ item.name }}</a>
                                        </template>
                                        </v-treeview>
                                    </v-col>-->
                                    <v-col cols="12" md="12">
                                        <v-row>
                                            <v-col cols="12" sm="3" md="2">
                                                <v-text-field
                                                    label="Nombre De Jour(s)"
                                                    v-model=avisTmp.nb_jours
                                                    @change="handlerVolume"
                                                    dense
                                                    number
                                                    outlined
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="3" md="2">
                                                <v-text-field
                                                    label="Longueur (m)"
                                                    v-model=avisTmp.longueur
                                                    @change="calculateVolume"
                                                    dense
                                                    type="number"
                                                    outlined
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="3" md="2">
                                                <v-text-field
                                                    label="Largeur (m)"
                                                    v-model=avisTmp.largeur
                                                    @change="calculateVolume"
                                                    dense
                                                    type="number"
                                                    outlined
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="3" md="2">
                                                <v-text-field
                                                    label="Tirant D'eau (m)"
                                                    v-model=avisTmp.max_draft
                                                    @change="calculateVolume"
                                                    dense
                                                    type="number"
                                                    outlined
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="3" md="2">
                                                <v-text-field
                                                    label="Volume (m³)"
                                                    dense
                                                    v-model="avisTmp.volume"
                                                    disabled
                                                    type="number"
                                                    outlined
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="3" md="2">
                                                Tirant D'eau théorique: {{Math.sqrt(avisTmp.largeur * avisTmp.longueur) * 0.14}}
                                            </v-col>
                                        </v-row>
                                        <v-data-table
                                        :headers="headersPrestations"
                                        hide-default-footer
                                        :items="prestations"
                                        :items-per-page=100
                                        item-key="code_prestation"
                                        :expanded.sync="expanded"
                                        show-expand
                                        >
                                        <template v-slot:expanded-item="{ headers, item }">
                                        <td :colspan="headers.length">
                                            <template v-if="item.code_prestation === 'DA001' || item.code_prestation === 'DA002'">
                                            <div style="float:left; width:15%; text-align:left;">
                                                <div class="note-btn" @click="item.noteStatus = !item.noteStatus">Note(s)</div>
                                                <v-textarea rows="2" dense small style="font-size:12px;" v-show="item.noteStatus == true" class="pt-0 mt-2" placeholder="Ajouter votre note ici..." v-model="item.note"></v-textarea>
                                                <template v-if="item.noteStatus == false">{{item.note}}</template>
                                            </div>
                                            <v-simple-table style="width:85%; float:right;">
                                                <template v-slot:default>
                                                <tbody>
                                                    <tr>
                                                    <td class="text-left" style="line-height:36px;"><v-text-field v-model="item.objects.perc" style="width:45px; float:left;" x-small dense></v-text-field>% de (Long X Larg X Tirant D'eau)</td>
                                                    <td class="text-left">
                                                        
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                        
                                                    </tr>
                                                </tbody>
                                                </template>
                                            </v-simple-table>
                                            </template>
                                            <template v-else-if="item.code_prestation === 'DA003'">
                                            <div style="float:left; width:15%; text-align:left;">
                                                <div class="note-btn" @click="item.noteStatus = !item.noteStatus">Note(s)</div>
                                                <v-textarea rows="2" dense small style="font-size:12px;" v-show="item.noteStatus == true" class="pt-0 mt-2" placeholder="Ajouter votre note ici..." v-model="item.note"></v-textarea>
                                                <template v-if="item.noteStatus == false">{{item.note}}</template>
                                            </div>
                                            <v-simple-table style="width:85%; float:right;" dense>
                                                <template v-slot:default>
                                                <tbody>
                                                    <tr>
                                                    <td class="text-left" style="line-height:53px;" colspan="3">
                                                        <div style="display:inline-flex;">
                                                            Nombre d'heure(s): 
                                                            <v-text-field v-model="item.objects.hours" class="pa-2" outlined style="width:95px; margin-left:15px;" hide-details x-small dense></v-text-field>
                                                        </div>
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Pilotage In</td>
                                                        <td>
                                                            <div style="display:inline-flex; line-height:36px;">
                                                                F/F par Heure: 
                                                                <v-text-field v-model="item.objects.ffin" style="width:45px; margin-left:15px;" x-small dense></v-text-field>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div style="display:inline-flex; line-height:36px;">
                                                                <v-text-field v-model="item.objects.puin" style="width:45px; margin-left:15px;" x-small dense></v-text-field> % de (Long X Larg X Tirant D'eau)
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Pilotage Out</td>
                                                        <td>
                                                            <div style="display:inline-flex; line-height:36px;">
                                                                F/F par Heure: 
                                                                <v-text-field v-model="item.objects.ffout" style="width:45px; margin-left:15px;" x-small dense></v-text-field>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div style="display:inline-flex; line-height:36px;">
                                                                <v-text-field v-model="item.objects.puout" style="width:45px; margin-left:15px;" x-small dense></v-text-field> % de (Long X Larg X Tirant D'eau)
                                                                
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                </template>
                                            </v-simple-table>
                                            </template>
                                            <template v-else-if="item.code_prestation === 'DA004'">
                                                <div style="float:left; width:15%; text-align:left;">
                                                    <div class="note-btn" @click="item.noteStatus = !item.noteStatus">Note(s)</div>
                                                    <v-textarea rows="2" dense small style="font-size:12px;" v-show="item.noteStatus == true" class="pt-0 mt-2" placeholder="Ajouter votre note ici..." v-model="item.note"></v-textarea>
                                                    <template v-if="item.noteStatus == false">{{item.note}}</template>
                                                </div>
                                                <v-simple-table style="width:85%; float:right;" dense>
                                                    <template v-slot:default>
                                                    <tbody>
                                                        <tr>
                                                            <td>Mooring</td>
                                                            <td>
                                                                <div style="display:inline-flex; line-height:36px;">
                                                                    Nombre d'amarre: 
                                                                    <v-text-field v-model="item.objects.nbin" style="width:45px; margin-left:15px;" x-small dense></v-text-field>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div style="display:inline-flex; line-height:36px;">
                                                                    PU par amarre : <v-text-field v-model="item.objects.puin" style="width:45px; margin-left:15px;" x-small dense></v-text-field> 
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Unmooring</td>
                                                            <td>
                                                                <div style="display:inline-flex; line-height:36px;">
                                                                    Nombre d'amarre: 
                                                                    <v-text-field v-model="item.objects.nbout" style="width:45px; margin-left:15px;" x-small dense></v-text-field>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div style="display:inline-flex; line-height:36px;">
                                                                    PU par amarre : <v-text-field v-model="item.objects.puout" style="width:45px; margin-left:15px;" x-small dense></v-text-field>
                                                                    
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </template>
                                            <template v-else-if="item.code_prestation === 'DA005'">
                                                <div style="float:left; width:15%; text-align:left;">
                                                    <div class="note-btn" @click="item.noteStatus = !item.noteStatus">Note(s)</div>
                                                    <v-textarea rows="2" dense small style="font-size:12px;" v-show="item.noteStatus == true" class="pt-0 mt-2" placeholder="Ajouter votre note ici..." v-model="item.note"></v-textarea>
                                                    <template v-if="item.noteStatus == false">{{item.note}}</template>
                                                </div>
                                                <v-simple-table style="width:85%; float:right;">
                                                    <template v-slot:default>
                                                    <tbody>
                                                        <tr>
                                                        <td class="text-left" style="line-height:36px;"><v-text-field v-model="item.objects.perc" style="width:45px; float:left;" x-small dense></v-text-field>% de (Shelting Dues + Berth Dues)</td>
                                                        <td class="text-left">
                                                            
                                                        </td>
                                                        </tr>
                                                        <tr>
                                                            
                                                        </tr>
                                                    </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </template>
                                            <template v-if="item.code_prestation === 'DA006'">
                                            <div style="float:left; width:15%; text-align:left;">
                                                <div class="note-btn" @click="item.noteStatus = !item.noteStatus">Note(s)</div>
                                                <v-textarea rows="2" dense small style="font-size:12px;" v-show="item.noteStatus == true" class="pt-0 mt-2" placeholder="Ajouter votre note ici..." v-model="item.note"></v-textarea>
                                                <template v-if="item.noteStatus == false">{{item.note}}</template>
                                            </div>
                                            <v-simple-table style="width:85%; float:right;">
                                                <template v-slot:default>
                                                <tbody>
                                                    <tr>
                                                    <td class="text-left" style="line-height:36px;">
                                                        <v-text-field v-model="item.objects.perc" style="width:45px;  display: inline-block;" x-small dense></v-text-field>% de (Long X Larg X Tirant D'eau)
                                                    </td>
                                                    <td class="text-left" style="line-height:36px;">
                                                        Number of Tugs : 
                                                        <v-text-field v-model="item.objects.nb_tower" style="width:45px; display: inline-block;" x-small dense></v-text-field>
                                                    </td>
                                                    <td class="text-left" style="line-height:36px;">
                                                        Number of hours used Tug :
                                                        <v-text-field v-model="item.objects.nb_hours" style="width:45px;  display: inline-block;" x-small dense></v-text-field>
                                                    </td>
                                                    </tr>
                                                </tbody>
                                                </template>
                                            </v-simple-table>
                                            </template>
                                            <template v-if="item.code_prestation === 'DA007'">
                                            <div style="float:left; width:15%; text-align:left;">
                                                <div class="note-btn" @click="item.noteStatus = !item.noteStatus">Note(s)</div>
                                                <v-textarea rows="2" dense small style="font-size:12px;" v-show="item.noteStatus == true" class="pt-0 mt-2" placeholder="Ajouter votre note ici..." v-model="item.note"></v-textarea>
                                                <template v-if="item.noteStatus == false">{{item.note}}</template>
                                            </div>
                                            <v-simple-table style="width:85%; float:right;">
                                                <template v-slot:default>
                                                <tbody>
                                                    <tr>
                                                    <td class="text-left" style="line-height:36px;">Summer DWT : <v-text-field v-model="item.objects.dwt" style="width:45px; display:inline-block;" x-small dense></v-text-field></td>
                                                    <td class="text-left" style="line-height:36px;">
                                                        PUHT :
                                                        <v-text-field v-model="item.objects.priceByM" style="width:45px; display:inline-block;" x-small dense></v-text-field> €/m3</td>
                                                    </tr>
                                                    <tr>
                                                        
                                                    </tr>
                                                </tbody>
                                                </template>
                                            </v-simple-table>
                                            </template>
                                            <template v-else-if="item.code_prestation === 'DA008'">
                                                <div style="float:left; width:15%; text-align:left;">
                                                    <div class="note-btn" @click="item.noteStatus = !item.noteStatus">Note(s)</div>
                                                    <v-textarea rows="2" dense small style="font-size:12px;" v-show="item.noteStatus == true" class="pt-0 mt-2" placeholder="Ajouter votre note ici..." v-model="item.note"></v-textarea>
                                                    <template v-if="item.noteStatus == false">{{item.note}}</template>
                                                </div>
                                                <v-simple-table style="width:85%; float:right;">
                                                    <template v-slot:default>
                                                    <tbody>
                                                        <tr v-for="(row,key ) in item.objects.dates" v-bind:key="key">
                                                        <td class="text-left" style="line-height:36px;"><v-text-field v-model="row.dayNumber" style="width:45px; float:left;" x-small dense></v-text-field> {{row.dateType}} </td>
                                                        <td class="text-left" style="line-height:36px;">
                                                            PUHT : <v-text-field v-model="row.datePrice" style="width:45px; display: inline-block;" x-small dense></v-text-field> TND = {{(row.datePrice / avisTmp.cour).toFixed(2)}} EUR
                                                        </td>
                                                        </tr>
                                                        <tr>
                                                            
                                                        </tr>
                                                    </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </template>
                                            <template v-else-if="item.code_prestation === 'DA009'">
                                                <div style="float:left; width:15%; text-align:left;">
                                                    <div class="note-btn" @click="item.noteStatus = !item.noteStatus">Note(s)</div>
                                                    <v-textarea rows="2" dense small style="font-size:12px;" v-show="item.noteStatus == true" class="pt-0 mt-2" placeholder="Ajouter votre note ici..." v-model="item.note"></v-textarea>
                                                    <template v-if="item.noteStatus == false">{{item.note}}</template>
                                                </div>
                                                <v-simple-table style="width:85%; float:right;">
                                                <template v-slot:default>
                                                <tbody>
                                                    <tr>
                                                    <td class="text-left" style="line-height:36px;">CBM Number : <v-text-field v-model="item.objects.cbm" style="width:45px; display:inline-block;" x-small dense></v-text-field> (Min 3 CBM)</td>
                                                    <td class="text-left" style="line-height:36px;">
                                                        PU/CBM :
                                                        <v-text-field v-model="item.objects.priceCbm" style="width:45px; display:inline-block;" x-small dense></v-text-field> €/m3</td>
                                                    </tr>
                                                    <tr>
                                                        
                                                    </tr>
                                                </tbody>
                                                </template>
                                            </v-simple-table>
                                            </template>
                                            <template v-else-if="item.code_prestation === 'DA010' || item.code_prestation === 'DA011'">
                                                <div style="float:left; width:15%; text-align:left;">
                                                    <div class="note-btn" @click="item.noteStatus = !item.noteStatus">Note(s)</div>
                                                    <v-textarea rows="2" dense small style="font-size:12px;" v-show="item.noteStatus == true" class="pt-0 mt-2" placeholder="Ajouter votre note ici..." v-model="item.note"></v-textarea>
                                                    <template v-if="item.noteStatus == false">{{item.note}}</template>
                                                </div>
                                            </template>
                                        </td>
                                        </template>
                                         <template v-slot:item="{ headers, item }">
                                             
                                            <tr v-if="item.code_prestation == 'Séparation'">
                                                <td class="text-left" :colspan="headers.length"><b>{{ item.description }}</b></td>
                                            </tr>
                                            <tr v-else-if="item.code_prestation == 'Total'">
                                                <template v-if="totals[item.description]">
                                                <td class="text-right" colspan="4"><b>{{ item.description }}</b></td>
                                                <td class="text-center"><b>{{Number(totals[item.description].totalff).toFixed(2)}} {{currencySign}}</b></td>
                                                <td class="text-center"><b>{{Number(totals[item.description].totalht).toFixed(2)}} {{currencySign}}</b></td>
                                                <td class="text-center"></td>
                                                <td class="text-center"><b>{{Number(totals[item.description].totaltva).toFixed(2)}} {{currencySign}}</b></td>
                                                <td class="text-center"><b>{{Number(totals[item.description].totalttc).toFixed(2)}} {{currencySign}}</b></td>
                                                <td class="text-center"></td>
                                                </template>
                                            </tr>
                                            <tr v-else>
                                                <td>
                                                    <template>
                                                        <div v-if="expanded.indexOf(item) === -1">
                                                            <v-btn small @click="expanded.push(item)" icon fab>
                                                            <v-icon
                                                            title="Détails">
                                                            mdi-chevron-down
                                                            </v-icon>
                                                            </v-btn>
                                                        </div>
                                                        <div v-else>
                                                            <v-btn small @click="expanded.splice(expanded.indexOf(item), 1)" icon fab>
                                                            <v-icon
                                                            title="Cacher les Détails">
                                                            mdi-chevron-up
                                                            </v-icon>
                                                            </v-btn>
                                                        </div>
                                                    </template>
                                                </td>
                                                <td>
                                                    <div class="heading-prests">{{item.code_prestation}}</div>
                                                </td>  
                                                
                                                <td>
                                                    <div><v-checkbox @change="handlerVolume" v-model="item.status"></v-checkbox></div>
                                                </td>
                                                
                                                 <td class="text-left heading-prests">
                                                    <v-edit-dialog
                                                    :return-value.sync="item.description"
                                                    > {{ item.description }}
                                                    <template v-slot:input>
                                                        <v-text-field
                                                        v-model="item.description"
                                                        label="Editer"
                                                        persistent
                                                        ></v-text-field>
                                                    </template>
                                                    </v-edit-dialog>
                                                </td>
                                                <td>
                                                    <v-edit-dialog
                                                    :return-value.sync="item.ff"
                                                    large
                                                    persistent
                                                    >
                                                    <div>{{Number(item.ff).toFixed(2)}}{{currencySign}}</div>
                                                    <template v-slot:input>
                                                        <div class="mt-4 title">Modifier les Frais Fixes</div>
                                                        <v-text-field
                                                        v-model="item.ff"
                                                        label="Editer"
                                                        single-line
                                                        :disabled="item.status !== true"
                                                        :messages="item.status === false? 'Veuillez cocher cette prestation pour pouvoir l\'éditer.' : ''"
                                                        type="Number"
                                                        autofocus
                                                        ></v-text-field>
                                                    </template>
                                                    </v-edit-dialog>
                                                </td>
 
                                                <td>
                                                    <div>{{item.montant.toFixed(2)}}{{currencySign}}</div>
                                                </td>  
                                                <td>
                                                    
                                                    <v-edit-dialog
                                                    :return-value.sync="item.tva"
                                                    large
                                                    persistent
                                                    >
                                                    <div>{{Number(item.tva).toFixed(0)}}</div>
                                                    <template v-slot:[`input`]>
                                                        <div class="mt-4 title">Modifier TVA</div>
                                                    </template>
                                                    <template v-slot:input>
                                                        <v-text-field
                                                        v-model="item.tva"
                                                        label="Edit"
                                                        single-line
                                                        counter
                                                        type="number"
                                                        autofocus
                                                        ></v-text-field>
                                                    </template>
                                                    </v-edit-dialog>
                                                </td>

                                                

                                                <td>
                                                    {{item.montantTva.toFixed(2)}}{{currencySign}}
                                                </td>
                                                

                                               
                                                
                                                
                                                <!--<td>
                                                    
                                                    <v-edit-dialog
                                                    :return-value.sync="item.montantDevise"
                                                    large
                                                    persistent
                                                    >
                                                    <div>{{Number(item.montantDevise).toFixed(2)}}</div>
                                                    <template v-slot:[`input`]>
                                                        <div class="mt-4 title">Modifier Montant Devise</div>
                                                    </template>
                                                    <template v-slot:input>
                                                        <v-text-field
                                                        v-model="item.montantDevise"
                                                        label="Edit"
                                                        single-line
                                                        counter
                                                        type="Number"
                                                        autofocus
                                                        ></v-text-field>
                                                    </template>
                                                    </v-edit-dialog>
                                                </td>
                                                <td>
                                                    
                                                    <v-edit-dialog
                                                    :return-value.sync="item.devise"
                                                    large
                                                    persistent
                                                    >
                                                    <div>{{item.devise}}</div>
                                                    <template v-slot:[`input`]>
                                                        <div class="mt-4 title">Modifier Devise</div>
                                                    </template>
                                                    <template v-slot:input>
                                                        <v-select label="Devise" v-model="item.devise" :items="['TND', 'USD', 'EUR']" autofocus required></v-select>
                                                    </template>
                                                    </v-edit-dialog>
                                                </td>
                                                <td>
                                                    
                                                    <v-edit-dialog
                                                    :return-value.sync="item.cour"
                                                    large
                                                    persistent
                                                    >
                                                    <div>{{Number(item.cour).toFixed(2)}}</div>
                                                    <template v-slot:[`input`]>
                                                        <div class="mt-4 title">Modifier Cours</div>
                                                    </template>
                                                    <template v-slot:input>
                                                        <v-text-field
                                                        v-model="item.cour"
                                                        label="Edit"
                                                        single-line
                                                        counter
                                                        type="number"
                                                        autofocus
                                                        ></v-text-field>
                                                    </template>
                                                    </v-edit-dialog>
                                                </td>-->
                                                <td  class="heading-prests">
                                                    
                                                    {{Number(item.montantttc).toFixed(2)}}{{currencySign}}
                                                </td>

                                                <td>
                                                    <v-icon
                                                        small
                                                        @click="deletePrestation(item)"
                                                    >
                                                        mdi-paperclip
                                                    </v-icon>
                                                </td>
                                            </tr>
                                        </template>
                                        <template slot="body.append">
                                            <tr>
                                                <th colspan="4" class="text-right total">Total</th>
                                                <th class="text-center total"><b>{{Number(totalff).toFixed(2)}} {{currencySign}}</b></th>
                                                <th class="text-center total"><b>{{Number(totalht).toFixed(2)}} {{currencySign}}</b></th>
                                                <th class="text-center total"><b></b></th>
                                                <th class="text-center total"><b>{{Number(totaltva).toFixed(2)}} {{currencySign}}</b></th>
                                                <th class="text-center total"><b>{{Number(totalttc).toFixed(2)}} {{currencySign}}</b></th>
                                                <th></th>
                                            </tr>
                                        </template>
                                        </v-data-table>


                                        <!--
                                        <v-row class="d-flex align-end flex-column mt-5">
                                            <v-col class="mt-auto" cols="12" md="6" style="text-align: right; font-size:16px; line-height:25px">
                                                Total : {{totaltva.toFixed(2)}} DT <br>
                                                VAT : {{totaltva.toFixed(2)}} {{currencySign}} <br>
                                                TTC {{currency}} : {{totalttc.toFixed(2)}} {{currencySign}} <br>
                                            </v-col>
                                        </v-row>-->
                                    </v-col>
                                </v-row>
                        </v-tab-item>
                        </v-tabs-items>

                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="hideModal">Annuler</v-btn>
                <v-btn style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white;" @click="addAvis" disabled dark>Ajouter</v-btn>
                </v-card-actions>
            </v-card>
</template>

<script>
export default {
    //name: "newAvis",
    props: ['currentDossier'],
    data: () => ({
    myvar: '',
    tab: null,
    itemsTabs: [
        'GENERAL', 'COSTS',
    ],
    snackbar: false,
    snackbarText: '',
    expanded: [],
    tree: null,
    color: "success",
    textTabs: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    items: [
        {
          id: 1,
          name: 'Préstations',
          children: [],
        },
        {
          id: 5,
          name: 'Fret',
          children: [],
        },
      ],
    valid: false,
    model: 1,
    editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    filterSelectbox: ['Tous','Import', 'Export'],
    searchPrest: '',    
    drawerClass: '',
    info: null,
    row: 'import',
    dialog: false,
    currency: 'EUR',
    currencySign: '€',
    businessCompanies: [
      {
        title: 'Import'
      },
      {
        title: 'Export'
      },
    ],
    desserts: [],
    headers: [
        {
        text: 'N°Dossier',
        sortable: false,
        value: 'numdossier',
        },
        { 
        text: 'Type', 
        value: 'type'
        },
        { text: 'Navire', value: 'navire' },
        { text: 'Voyage', value: 'voyage' },
        { text: 'Date d\'arrivée', value: 'from_date' },
        { text: 'Date de sortie', value: 'to_date' },
        { text: 'Escale', value: 'escale' },
        { text: 'Armateur', value: 'armateur' },
        { text: 'Port de chargement', value: 'port_from' },
        { text: 'Port de déchargement', value: 'port_to' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],
    todayDate: ("0"+new Date().getDate()).slice(-2)+'/'+("0"+(new Date().getMonth()+1)).slice(-2)+'/'+new Date().getFullYear(),
    todayDateSql: new Date().getFullYear()+'/'+("0"+(new Date().getMonth()+1)).slice(-2)+'/'+("0"+new Date().getDate()).slice(-2),
    infoRules: [
        v => !!v || 'Veuillez saisir une valeur',
    ],
    headersAvis: [
      {
        text: 'N°BL',
        sortable: false,
        value: 'nbl',
      },
      { text: 'Client / Armateur', value: 'client' },
      { text: 'N°Avis', value: 'numavis' },
      { text: 'Facture Import', value: 'factureimport' },
      { text: 'Correspondant', value: 'correspondant' },
      { text: 'Fournisseur', value: 'fournisseur' },
      { text: 'Nbre colis', value: 'nbrecolis' },
      { text: 'Poids', value: 'poids' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    headersMarchandises: [
        { text: 'Rub.', value: 'rub' },
        { text: 'Cont.Numéro', value: 'cont_numero' },
        { text: 'Cont.Type', value: 'conttype' },
        { text: 'Colis', value: 'colis' },
        { text: 'Description marchandise', value: 'description' },
        { text: 'Poids (Kg)', value: 'poids' },
        { text: 'Actions', value: 'actions' },
    ],
    headersMarchandisesAerien: [
        { text: 'Rub.', value: 'rub' },
        { text: 'Colis', value: 'colis' },
        { text: 'Description marchandise', value: 'description' },
        { text: 'Poids (Kg)', value: 'poids' },
        { text: 'Actions', value: 'actions' },
    ],
    headersMarchandisesGroupage: [
        { text: 'Rub.', value: 'rub' },
        { text: 'Colis', value: 'colis' },
        { text: 'Description marchandise', value: 'description' },
        { text: 'Poids (Kg)', value: 'poids' },
        { text: 'Volume', value: 'volume' },
        { text: 'Actions', value: 'actions' },
    ],
    marchandises: [],
    headersPrestations: [
        {
        text: 'Code',
        align: 'start',
        sortable: false,
        value: 'code_prestation',
        },
        { text: 'Status', value: 'status',sortable: false, },
        { text: 'Description des prestations',sortable: false, value: 'description' },
        { text: 'F/F',sortable: false, value: 'ff', align: 'center' },
        { text: 'Total HT',sortable: false, align: 'center', value: 'montant' },
        { text: 'TVA %',sortable: false, value: 'tva', align: 'center' },
        { text: 'Montant TVA',sortable: false,align: 'center', value: 'montantTva'},
        { text: 'Total TTC',sortable: false,align: 'center', value: 'montantttc' },
        { text: 'Actions', sortable: false,align: 'center',value: 'actions' },
    ],
    prestations: [
        {
            code_prestation: 'Séparation',
            description: '- Port Expenses'
        },
        {
            code_prestation: 'DA001',
            description: 'Shelting Dues',
            status: false,
            tva: 19,
            devise: 'EUR',
            cour: 0,
            ff: 0,
            montant: 0,
            montantDevise: 0,
            montantTva: 0,
            montantttc: 0,
            objects:{
                perc: 0
            },
            note: '',
            noteStatus: false
        },
        {
            code_prestation: 'DA002',
            description: 'Berth Dues',
            status: false,
            tva: 19,
            devise: 'EUR',
            ff: 0,
            cour: 0,
            montant: 0,
            montantDevise: 0,
            montantttc: 0,
            montantTva: 0,
            objects:{
                perc: 0
            },
            note: '',
            noteStatus: false
        },
        {
            code_prestation: 'DA003',
            description: 'Pilotage In / Out',
            status: false,
            tva: 19,
            devise: 'EUR',
            ff: 0,
            cour: 0,
            montant: 0,
            montantDevise: 0,
            montantttc: 0,
            montantTva: 0,
            objects: {
                hours: 1,
                puin: 0,
                puout: 0,
                ffin: 0,
                ffout: 0
            },
            note: '',
            noteStatus: false
        },
        {
            code_prestation: 'DA004',
            description: 'Mooring / Unmooring',
            status: false,
            tva: 19,
            devise: 'EUR',
            ff: 0,
            cour: 0,
            montant: 0,
            montantttc: 0,
            montantDevise: 0,
            montantTva: 0,
            objects:{
                nbin: 15, 
                nbout: 15, 
                puin: 0, 
                puout: 0, 
            },
            note: '',
            noteStatus: false
        },
        {
            code_prestation: 'DA005',
            description: 'ISPS',
            status: false,
            tva: 19,
            devise: 'EUR',
            ff: 0,
            cour: 0,
            montant: 0,
            montantDevise: 0,
            montantttc: 0,
            montantTva: 0,
            objects: {
                perc: 5
            },
            note: '',
            noteStatus: false
        },
        {
            code_prestation: 'DA006',
            description: 'Towage Charges',
            status: false,
            tva: 19,
            devise: 'EUR',
            ff: 0,
            cour: 0,
            montant: 0,
            montantttc: 0,
            montantDevise: 0,
            montantTva: 0,
            objects:{
                perc: 0, 
                nb_tower: 1, 
                nb_hours: 1
            },
            note: '',
            noteStatus: false
        },
        {
            code_prestation: 'DA007',
            description: 'Sanitery',
            status: false,
            tva: 19,
            devise: 'EUR',
            ff: 0,
            cour: 0,
            montant: 0,
            montantttc: 0,
            montantDevise: 0,
            montantTva: 0,
            objects:{
                dwt: 0, 
                priceByM: 0.006
            },
            note: '',
            noteStatus: false
        },
        {
            code_prestation: 'DA008',
            description: 'Watchman on Board',
            status: false,
            tva: 19,
            devise: 'EUR',
            ff: 0,
            cour: 0,
            montant: 0,
            montantttc: 0,
            montantDevise: 0,
            montantTva: 0,
            objects: {
                dates: [
                    {dateType: 'Jour(s) ouvrable(s) (de 06:00 à 18:00)', datePrice: 120, dayNumber: 0},
                    {dateType: 'Jour(s) ouvrable(s) (nuit) (de 18:00 à 06:00)', datePrice: 180 , dayNumber: 0},
                    {dateType: 'Jour(s) de Fête officielle (de 06:00 à 18:00)', datePrice: 180 , dayNumber: 0},
                    {dateType: 'Jour(s) de Fête officielle (nuit)  (de 18:00 à 06:00)', datePrice: 240 , dayNumber: 0},
                ]
            },
            note: '',
            noteStatus: false
        },
        {
            code_prestation: 'DA009',
            description: 'Garbage Removal Dues',
            status: false,
            tva: 19,
            devise: 'EUR',
            ff: 0,
            cour: 0,
            montant: 0,
            montantttc: 0,
            montantDevise: 0,
            montantTva: 0,
            objects: {
                cbm: 3,
                priceCbm: 70
            },
            note: '',
            noteStatus: false
        },
        {
            code_prestation: 'DA010',
            description: 'Clearance',
            status: false,
            tva: 19,
            devise: 'EUR',
            ff: 0,
            cour: 0,
            montant: 0,
            montantttc: 0,
            montantDevise: 0,
            montantTva: 0,
            note: '',
            noteStatus: false
        },  
        {
            code_prestation: 'Total',
            description: 'Total - Port Expenses',
            total: {}
        },      
        {
            code_prestation: 'Séparation',
            description: '- Agency Fees'
        },
        {
            code_prestation: 'DA011',
            description: 'Agency Fee (2100 EUR Per Call)',
            status: false,
            tva: 19,
            devise: 'EUR',
            ff: 0,
            cour: 0,
            montantttc: 0,
            montant: 0,
            montantDevise: 0,
            montantTva: 0,
            note: '',
            noteStatus: false
        },
        {
            code_prestation: 'Total',
            description: 'Total - Agency Fees',
            total: {}
        },
    ],
    marchandiseTmp: {
        conttype: null,
        rub: '',
        cont_numero: null,
        colis: '',
        description: '',
        poids: '',
        volume: null
    },
    avisTmp: {
        dossier_id: 0,
        num_avis: '',
        max_draft: 0,
        longueur: 0,
        largeur: 0,
        nb_jours: 0,
        volume: 0,
        pc: '',
        terme: '',
        expediteur: '',
        agent_id : '',
        correspondant_id: '',
        client_id: '',
        bl: '',
        expediteur: '',
        cour: 3.12,
        devise: 'EUR'
    },
    consigList: [],
    conteneurList: [],
    correspondantList: [],
    agentList: [],
    agent: '',
    correspondant: '',
    totalff: 0,
    totalht: 0,
    totaltva: 0,
    totalttc: 0,
    avisTmpData: {},
    clients: [],
    prestListTmp: [],
    volumeTmp: 0,
    totals: {}
  }),
  watch: {
    prestations: {
      deep: true,
      handler: 'calculate'
    },
    'avisTmp.volume': {
        deep: true,
        handler: 'handlerVolume'
    }
  },
    created() {
        this.axios
            .get('getPermissionByCredentials/'+this.$store.getters.getUser)
            .then(response => {
                if(response.data.data.indexOf('add_avis') === -1){
                    this.$router.push({name: 'notAllowed'})
                }
            })
    },
    mounted () {
            this.axios
            .get('/avis/listing')
            .then(response => (this.setAvisNumber(response.data)))

            this.axios
            .get('/correspondant/listing')
            .then(response => (this.correspondantList = response.data))

            this.axios
            .get('/agent/listing')
            .then(response => (this.agentList = response.data))

            this.axios
            .get('/conteneur/listing')
            .then(response => (this.conteneurList = response.data))

            this.axios
            .get('/client/listing')
            .then(response => (this.clients = response.data))

            this.axios
            .get('/prestation/listing')
            .then(response => {
                    var prestList = response.data
                    function compare(a, b) {
                        // Use toUpperCase() to ignore character casing
                        const A = a.type_prestation;
                        const B = b.type_prestation;

                        let comparison = 0;
                        if (A < B) {
                            comparison = 1;
                        } else if (A > B) {
                            comparison = -1;
                        }
                        return comparison;
                    }
                    prestList.sort(compare)
                    prestList.forEach((item, index) => {
                        if(item.impoexpo === this.currentDossier.type){
                            //item.id = index+1
                            item.name = item.description
                            item.prestation = item
                            if(item.cour === null){
                                item.cour = 0
                            }
                            if(item.montantDevise === null){
                                item.montantDevise = 0
                            }
                            if(item.type_prestation === 'Préstation'){
                                this.items[0].children.push(item)
                            }else{
                                this.items[1].children.push(item)
                            }
                        }
                    })
                }
            )
        let self = this
        setTimeout(() =>{
            self.calculate()
        },300)

        },
  methods: {
    changeCurrency(){
        if(this.avisTmp.devise == 'EUR'){
            this.currency = 'EUR'
            this.currencySign = '€'
        }else if(this.avisTmp.devise == 'USD'){
            this.currency = 'USD'
            this.currencySign = '$'
        }
    },
    handlerVolume(){
        var index = this.prestations.indexOf(this.prestations.filter(obj => {return obj.code_prestation === 'DA001'})[0])
        var index2 = this.prestations.indexOf(this.prestations.filter(obj => {return obj.code_prestation === 'DA002'})[0])
        var index3 = this.prestations.indexOf(this.prestations.filter(obj => {return obj.code_prestation === 'DA003'})[0])
        var index4 = this.prestations.indexOf(this.prestations.filter(obj => {return obj.code_prestation === 'DA004'})[0])
        var index6 = this.prestations.indexOf(this.prestations.filter(obj => {return obj.code_prestation === 'DA006'})[0])
        var index8 = this.prestations.indexOf(this.prestations.filter(obj => {return obj.code_prestation === 'DA008'})[0])
        var index9 = this.prestations.indexOf(this.prestations.filter(obj => {return obj.code_prestation === 'DA009'})[0])
        if(Number(this.avisTmp.volume) > 0){
            var x = Number(this.avisTmp.volume)
            if(x <= 10000){
                this.prestations[index].objects.perc = 8.76
                this.prestations[index].ff = 0
                this.prestations[index2].objects.perc = 5.9
                this.prestations[index2].ff = 0
                if(x > 1000){
                    this.prestations[index3].objects.ffin = 110.4
                    this.prestations[index3].objects.ffout = 110.4
                    this.prestations[index3].objects.puin = 1.07
                    this.prestations[index3].objects.puout = 1.07
                    this.prestations[index6].objects.perc = 3.034
                    this.prestations[index6].ff = 114
                }else{
                    this.prestations[index3].objects.ffin = 0
                    this.prestations[index3].objects.ffout = 0
                    this.prestations[index3].objects.puin = 110.4
                    this.prestations[index3].objects.puout = 110.4
                    this.prestations[index6].objects.perc = 114
                    this.prestations[index6].ff = 0
                }
                this.prestations[index4].objects.puin = 6
                this.prestations[index4].objects.puout = 6

                this.volumeTmp = x
                
            }else if(x > 10000 && x <= 25000){
                this.prestations[index].objects.perc = 8.04
                this.prestations[index].ff = 876

                this.prestations[index2].objects.perc = 5.36
                this.prestations[index2].ff = 590

                this.prestations[index3].objects.ffin = 206.4
                this.prestations[index3].objects.ffout = 206.4
                this.prestations[index3].objects.puin = 0.96
                this.prestations[index3].objects.puout = 0.96

                this.prestations[index4].objects.puin = 12
                this.prestations[index4].objects.puout = 12

                this.prestations[index6].objects.perc = 2.66
                this.prestations[index6].ff = 287
                this.volumeTmp = x - 10000
            }else if(x > 25000 && x <= 40000){
                this.prestations[index].objects.perc = 7.32
                this.prestations[index].ff = 2082
                this.prestations[index2].objects.perc = 4.96
                this.prestations[index2].ff = 1394

                this.prestations[index3].objects.ffin = 350.4
                this.prestations[index3].objects.ffout = 350.4
                this.prestations[index3].objects.puin = 0.91
                this.prestations[index3].objects.puout = 0.91
                this.prestations[index4].objects.puin = 15
                this.prestations[index4].objects.puout = 15

                this.prestations[index6].objects.perc = 2.40
                this.prestations[index6].ff = 786
                this.volumeTmp = x - 25000
            }else if(x > 40000 && x <= 75000){
                this.prestations[index].objects.perc = 6.96
                this.prestations[index].ff = 3180
                this.prestations[index2].objects.perc = 4.7
                this.prestations[index2].ff = 2138
                this.prestations[index3].objects.ffin = 487.2
                this.prestations[index3].objects.ffout = 487.2
                this.prestations[index3].objects.puin = 0.86
                this.prestations[index3].objects.puout = 0.86
                this.prestations[index4].objects.puin = 18
                this.prestations[index4].objects.puout = 18
                this.prestations[index6].objects.perc = 2.36
                this.prestations[index6].ff = 1146
                this.volumeTmp = x - 40000
            }else if(x > 75000 && x <= 150000){
                this.prestations[index].objects.perc = 6.48
                this.prestations[index].ff = 5616
                this.prestations[index2].objects.perc = 4.4
                this.prestations[index2].ff = 3783
                this.prestations[index3].objects.ffin = 781.2
                this.prestations[index3].objects.ffout = 781.2
                this.prestations[index3].objects.puin = 0.84
                this.prestations[index3].objects.puout = 0.84
                this.prestations[index4].objects.puin = 20
                this.prestations[index4].objects.puout = 20
                this.prestations[index6].objects.perc = 0.68
                this.prestations[index6].ff = 1972
                this.volumeTmp = x - 75000
            }else if(x > 150000){
                this.prestations[index].objects.perc = 6.24
                this.prestations[index].ff = 10476
                this.prestations[index2].objects.perc = 4.15
                this.prestations[index2].ff = 7083
                this.prestations[index3].objects.ffin = 1419.6
                this.prestations[index3].objects.ffout = 1419.6
                this.prestations[index3].objects.puin = 0.77
                this.prestations[index3].objects.puout = 0.77
                this.prestations[index4].objects.puin = 25
                this.prestations[index4].objects.puout = 25
                this.prestations[index6].objects.perc = 0.61
                this.prestations[index6].ff = 2210
                this.volumeTmp = x - 150000
            }
        }
        let to = new Date(this.currentDossier.to_date)
        to = new Date(to.setDate(to.getDate() + Number(this.avisTmp.nb_jours)))
        this.prestations[index8].objects.dates[0].dayNumber = 0
        this.prestations[index8].objects.dates[1].dayNumber = 0
        this.prestations[index8].objects.dates[2].dayNumber = 0
        this.prestations[index8].objects.dates[3].dayNumber = 0
        for (var d = new Date(this.currentDossier.to_date); d < to; d.setDate(d.getDate() + 1)) {
            let date = new Date(d)
            if(date.getDay() == 0 || date.getDay() == 6){
                this.prestations[index8].objects.dates[2].dayNumber += 1
                this.prestations[index8].objects.dates[3].dayNumber += 1
            }else{
                this.prestations[index8].objects.dates[0].dayNumber += 1
                this.prestations[index8].objects.dates[1].dayNumber += 1
            }
        }

        this.calculate()
    },
    calculateVolume(){
        this.avisTmp.volume = Number(this.avisTmp.max_draft * this.avisTmp.largeur * this.avisTmp.longueur)
    },
    setAvisNumber(avis){
        if(avis.length > 0){
            var nextCode = avis.reduce((max, p) => p.num_avis > max ? p.num_avis : max, avis[0].num_avis)
            if(Number(nextCode.slice(0, 4)) === new Date().getFullYear() ) {
                nextCode = Number(nextCode)+1;
            }else{
                nextCode = new Date().getFullYear()+'0001'
            }
        }else{
            nextCode = new Date().getFullYear()+'0001'
        }
        this.avisTmp.num_avis = nextCode
        this.avisTmp.dossier_id = this.currentDossier.id
        

    },
    selectPrest(code, key){
        this.axios
            .get('/prestation/listing')
            .then(response => {
                var result = response.data.filter(obj => {
                return obj.code_prestation === code
                })[0]
                if(this.prestations.filter(obj => obj.code_prestation === result.code_prestation).length > 0){
                    this.color = "error"
                    this.snackbar = true
                    this.snackbarText = "Cette préstation est déjà insérée."
                }else{
                    if(!key)
                        key = 0
                    result.key = key+1
                    this.prestations.push(result)
                }
            }
        )
    },
    calculateDA(prest){
        let result = {
            montant: 0,
            montantttc: 0
        }
        if(prest.code_prestation === 'DA001'){
            result.montant = (Number(prest.objects.perc) * Number(this.volumeTmp) / 100) + Number(prest.ff)
            result.montantttc = Number(prest.montantTva) + Number(prest.ff) + result.montant 
            return result
        }else if(prest.code_prestation === 'DA002'){
            result.montant = ((Number(prest.objects.perc) * Number(this.volumeTmp) / 100) + Number(prest.ff) ) * Number(this.avisTmp.nb_jours)
            result.montantttc = Number(prest.montantTva) + result.montant 
            return result
        }else if(prest.code_prestation === 'DA003'){
            let volumetmp = this.volumeTmp
            if(volumetmp > 1000){
                volumetmp = volumetmp - 1000
            }
            result.ff = (Number(prest.objects.ffin) + Number(prest.objects.ffout) ) * Number(prest.objects.hours)
            result.montant = ( (Number(prest.objects.puin) * Number(volumetmp) / 100) + Number(prest.objects.ffin) + (Number(prest.objects.puout) * Number(volumetmp) / 100) + Number(prest.objects.ffout) ) * Number(prest.objects.hours)
            result.montantttc = Number(prest.montantTva) + result.montant 
            return result
        }else if(prest.code_prestation === 'DA004'){
            result.montant = (Number(prest.objects.nbin) * Number(prest.objects.puin) + (Number(prest.objects.nbout) * Number(prest.objects.puout)) )
            result.montantttc = Number(prest.montantTva) + result.montant 
            return result
        }else if(prest.code_prestation === 'DA005'){
            result.montant = (Number(prest.objects.perc) * (this.prestations.filter(obj => {return obj.code_prestation === 'DA001'})[0].montant + this.prestations.filter(obj => {return obj.code_prestation === 'DA002'})[0].montant ) ) / 100
            result.montantttc = Number(prest.montantTva) + result.montant 
            return result
        }else if(prest.code_prestation === 'DA006'){
            let volumetmp = this.volumeTmp
            if(volumetmp > 1000){
                volumetmp = volumetmp - 1000
            }
            result.montant = ((Number(prest.objects.perc) * Number(volumetmp) / 100) + Number(prest.ff) ) * Number(prest.objects.nb_tower) * Number(prest.objects.nb_hours)
            result.montantttc = Number(prest.montantTva) + result.montant 
            return result
        }else if(prest.code_prestation === 'DA007'){
            result.montant = (Number(prest.objects.dwt) * Number(prest.objects.priceByM) ) + Number(prest.ff)
            result.montantttc = Number(prest.montantTva) + result.montant
            return result
        }else if(prest.code_prestation === 'DA008'){
            result.montant = 
            (Number(prest.objects.dates[0].datePrice) * Number(prest.objects.dates[0].dayNumber) / Number(this.avisTmp.cour) ) + 
            (Number(prest.objects.dates[1].datePrice) * Number(prest.objects.dates[1].dayNumber) / Number(this.avisTmp.cour) ) + 
            (Number(prest.objects.dates[2].datePrice) * Number(prest.objects.dates[2].dayNumber) / Number(this.avisTmp.cour) ) + 
            (Number(prest.objects.dates[3].datePrice) * Number(prest.objects.dates[3].dayNumber) / Number(this.avisTmp.cour) ) + 
            Number(prest.ff)
            result.montantttc = Number(prest.montantTva) + result.montant
            return result
        }else if(prest.code_prestation === 'DA009'){
            result.montant = Number(prest.objects.cbm) * Number(prest.objects.priceCbm) + Number(prest.ff)
            result.montantttc = Number(prest.montantTva) + result.montant
            return result
        }else if(prest.code_prestation === 'DA010'){
            result.montant = Number(prest.ff)
            result.montantttc = Number(prest.montantTva) + result.montant
            return result
        }else if(prest.code_prestation === 'DA011'){
            result.montant = Number(prest.ff)
            result.montantttc = Number(prest.montantTva) + result.montant
            return result
        }else{
            return null
        }
    },
    calculate(){
        this.totalff = 0
        this.totalht = 0
        this.totaltva = 0
        this.totalttc = 0
        let section_total = {
                    totalff: 0,
                    totalht: 0,
                    totalttc: 0,
                    totaltva: 0
                }
        this.prestations.forEach((item , index) => {
            if(item.code_prestation !== 'Séparation' && item.code_prestation !== 'Total'){
                if(item.status == false){
                    item.ff = 0
                    item.montant = 0
                    item.montantttc = 0
                    item.montantTva = 0
                    this.prestations[index] = item
                }else{
                    item.cour = Number(item.cour)
                    item.montant = Number(item.montant)
                    item.montantDevise = Number(item.montantDevise)
                    item.tva = Number(item.tva)
                    item.montantTva = Number(item.montant.toFixed(2)) * item.tva / 100
                    let c = this.calculateDA(item)
                    let aux = item
                    if(c !== null)
                        aux = Object.assign(item, c)
                    
                    this.prestations[index] = aux
                    section_total.totalff += Number(aux.ff)
                    section_total.totalht += Number(aux.montant)
                    section_total.totaltva += Number(aux.montantTva)
                    section_total.totalttc += Number(aux.montantttc)
                }
            
            }else if(item.code_prestation === 'Total'){
                this.totals[item.description] = section_total
                this.totalff += Number(section_total.totalff)
                this.totalht += Number(section_total.totalht)
                this.totalttc += Number(section_total.totalttc)
                this.totaltva += Number(section_total.totaltva)
                section_total = {
                    totalff: 0,
                    totalht: 0,
                    totalttc: 0,
                    totaltva: 0
                }
            }
            
        })
        //this.total = Number(this.total.toFixed(2)) + Number(this.totalnt.toFixed(2)) + Number(this.totalt.toFixed(2)) + Number(this.totaltva.toFixed(2))
    },
    addMarchandise(){
        if(this.currentDossier.classe == 'Complet'){
            this.marchandiseTmp.cont_type_id = this.conteneurList.filter(obj => {
                return obj.titre === this.marchandiseTmp.conttype
            })[0].id
        }
        this.marchandises.push(this.marchandiseTmp)
        this.marchandiseTmp = {}
                    
    },
    updateMarchandiseContType(item){
        console.log(this.marchandises.indexOf(item))
        const index = this.marchandises.indexOf(item)
        this.marchandises[index].cont_type_id = this.conteneurList.filter(obj => {
              return obj.titre === this.marchandises[index].conttype
            })[0].id
    },
    deleteMarchandises (item) {
        const index = this.marchandises.indexOf(item)
        confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?') && this.marchandises.splice(index, 1)
    },
    deletePrestation (item) {
        const index = this.prestations.indexOf(item)
        confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?') && this.prestations.splice(index, 1)
    },
    hideModal() {
        this.$emit('hide');
    },
    addAvis(){
        if(this.valid === false){
            this.color = "error"
            this.snackbar = true
            this.snackbarText = "Veuillez remplir tous les champs obligatoires."
        }else{
            this.avisTmpData.generals = {
                num_avis: this.avisTmp.num_avis,
                dossier_id: this.currentDossier.id,
                bl: this.avisTmp.bl,
                date: this.todayDateSql,
                correspondant_id: this.avisTmp.correspondant_id,
                agent_id: this.avisTmp.agent_id,
                pc: this.avisTmp.pc,
                terme: this.avisTmp.terme,
                fournisseur: this.avisTmp.fournisseur,
                client_id: this.avisTmp.client_id,
                bureau: this.avisTmp.bureau,
                code_magasin: this.avisTmp.code_magasin,
                valeur: this.avisTmp.valeur
            }
            this.avisTmpData.prestations = []
            this.avisTmpData.marchandise = []
            this.prestations.forEach((item, index) => {
                delete item.prestation
                delete item.name
                delete item.id
                delete item.datetime
                delete item.montantTva
                delete item.key
                this.avisTmpData.prestations.push(item)
            })
            this.marchandises.forEach((item, index) => {
                delete item.conttype
                this.avisTmpData.marchandise.push(item)
            })
            this.axios.post('/avis/create', this.avisTmpData, {
            }).then((res) => {
                if(res.data === 'error'){
                this.color = "error"
                this.snackbarText = "Essayez de remplir tous les champs obligatoires."
                this.snackbar = true
                }else{
                this.color = "success"
                this.snackbarText = "L'avis a été ajouté avec succès."
                this.snackbar = true
                this.$emit('reloadData')
                setTimeout( () => this.hideModal(), 1000)
                }
            }).catch(e => {
                this.color = "error"
                this.snackbar = true
                this.snackbarText = "Un erreur est survenu, essayez plus tard."
                console.log(e)
            })
        }
    },
  }
}
</script>
<style scoped>
.total{
    font-size:16px !important;
    font-weight:700;
}
.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper){
    background: transparent !important;
}
.note-btn{
    border-radius: 15px;
    font-size:11px;
    display:inline-block;
    width:fit-content;
    background: linear-gradient(90deg, rgb(13, 74, 186) 0%, rgb(9, 155, 223) 100%);
    padding: 5px 15px;
    color: white;
    font-weight: 700;
    margin: 15px;
    margin-bottom:0px;
}
.heading-prests{
    font-weight: 700;
    /*color: #1c66ee;*/
}
.v-card__actions{
    position: absolute;
    bottom: 0;
    right: 0;
}
.avis-tab.v-tab:before{
    border-radius: 10px 50px 0 0;
}
.avis-tab.v-tab{
    background: #ebebeb;
    border-top-right-radius: 50px;
    border-top-left-radius: 15px;
    color: white;
}
.avis-tab.v-tab--active{
    border-top-right-radius: 50px;
    border-top-left-radius: 15px;
    color: white;
    background: linear-gradient(90deg, rgb(13, 74, 186) 0%, rgb(9, 155, 223) 100%);
}
.v-input.v-text-field >>> .v-input__slot{
    box-shadow:0  10px 15px rgba(0,0,0,0.05);
}
</style>


// WEBPACK FOOTER //
// src/views/dashboard/dossier/da/new.component.vue